"use client"; 

import { Suspense } from "react";
import AuthProvider from '@/components/sessionProvider/AuthProvider';
import Nav from "@/components/layout/nav";
import Footer from "@/components/layout/footer";
import 'bootstrap/dist/css/bootstrap.css';
import { usePathname } from "next/navigation";

export default function WebLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();  
  const hideFooter = pathname === "/pricing/pricing-plan";
  
  return (
    <AuthProvider>
      <div className="w-full overflow-x-hidden">
        <Suspense fallback={<p>...</p>}>
          <Nav />
        </Suspense>
        <main className="flex flex-col pb-0 items-center overflow-x-hidden">
          {children}
        </main>
        {!hideFooter && <Footer />}
      </div>
    </AuthProvider>
  );
}
